module.exports = __webpack_public_path__ + "f3f12ff3bada4c24019f5e66cea17f61.jpg";